import { render, staticRenderFns } from "./oil.vue?vue&type=template&id=245bfa09&"
import script from "./js/oil.js?vue&type=script&lang=js&"
export * from "./js/oil.js?vue&type=script&lang=js&"
import style0 from "./oil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports